export class ExpiredCruiseError extends Error {
    constructor(message) {
        super(message);
        this.name = 'ExpiredCruiseError';
    }
}
